import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'persianCurrency'
})
export class PersianCurrencyPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value && args === 'slash') {
      return String(value).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1/');
    } else if (value && args === 'comma') {
      return String(value).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    } else {
      return String(value).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1/');
    }
  }

}
